/** Thermal printer paper width (printable area). */
export const THERMAL_WIDTH_MM = 72.1;

export const THERMAL_PADDING_V_MM = 2.5;
export const THERMAL_PADDING_H_MM = 2;

/** Extra width for preview roll chrome above receipt. */
export const THERMAL_PREVIEW_ROLL_EXTRA_MM = 8;
